<template>
  <div class="my-address">
    <div
      class="address-box"
      v-for="(item, index) of addressList"
      :key="item.id"
      :class="item.is_default === 1 ? 'active' : ''"
    >
      <div class="address-header">
        <span>
          {{ item.real_name }}
        </span>
        <div class="address-action">
          <span @click="edit(index)"><Icon type="edit"></Icon> 修改</span>
          <span @click="del(index)"><Icon type="trash-a"></Icon> 删除</span>
        </div>
      </div>
      <div class="content-box">
        <div class="address-content">
          <p>
            <span class="address-content-title"> 收 货 人 :</span>
            <span>{{ item.real_name }}</span>
          </p>
          <p>
            <span class="address-content-title">收货地区:</span>
            <span>{{ item.province }} {{ item.city }} {{ item.district }}</span>
          </p>
          <p>
            <span class="address-content-title">详细地址:</span>
            <span
              >{{ item.province }} {{ item.city }} {{ item.district }}
              {{ item.detail }} {{ item.real_name }} {{ item.phone }}</span
            >
          </p>
        </div>
      </div>
      <div class="setDefault" v-if="!item.is_default">
        <i-switch
          v-model="addressList[index].is_default"
          @on-change="changeSwitch(index)"
        />
        <div class="title">
          设为默认地址
        </div>
      </div>
      <!-- <div class="setDefault default-color" v-if="item.is_default">
        <i-switch :disabled="true" />
        <div class="title">
          默认地址
        </div>
      </div> -->
    </div>
    <div>
      <Modal v-model="showModel" width="600">
        <p slot="header">
          <Icon type="edit"></Icon>
          <span>修改地址</span>
        </p>
        <div>
          <Form
            :model="formData"
            label-position="left"
            :label-width="100"
            :rules="ruleInline"
          >
            <FormItem label="收件人" prop="real_name">
              <i-input v-model="formData.real_name" size="large"></i-input>
            </FormItem>
            <FormItem label="收件地区" prop="address">
              <div @click.stop="show2 = true">
                <i-input v-model="modelAdress" size="large"></i-input>
              </div>
              <CitySelect
                v-model="show2"
                :callback="result2"
                :items="district"
                provance=""
                city=""
                area=""
              ></CitySelect>
            </FormItem>
            <FormItem label="详细地址" prop="detail">
              <i-input v-model="formData.detail" size="large"></i-input>
            </FormItem>
            <FormItem label="手机号码" prop="phone">
              <i-input v-model="formData.phone" size="large"></i-input>
            </FormItem>
          </Form>
        </div>
        <div slot="footer">
          <Button type="primary" size="large" long @click="editAction"
            >修改</Button
          >
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  getAddressList,
  postAddress,
  getAddressRemove,
  getAddressDefaultSet
} from "@api/user";
import { CitySelect } from "vue-ydui/dist/lib.rem/cityselect";
import District from "ydui-district/dist/jd_province_city_area_id";
export default {
  name: "MyAddress",
  data() {
    return {
      showModel: false,
      formData: {
        real_name: "",
        address: {
          province: "",
          city: "",
          district: ""
        },
        phone: "",
        post_code: "",
        is_default: 0,
        detail: "",
        id: ""
      },
      ruleInline: {
        real_name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        detail: [
          { required: true, message: "请输入详细地址", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "手机号不能为空", trigger: "blur" },
          {
            type: "string",
            pattern: /^1[3|4|5|7|8][0-9]{9}$/,
            message: "手机号格式出错",
            trigger: "blur"
          }
        ]
      },
      param: {
        page: 1,
        limit: 20
      },
      addressList: [],
      district: District,
      show2: false,
      modelAdress: ""
    };
  },
  created() {
    this.getAddressListMethods();
  },
  computed: {
    ...mapState(["userInfo"])
  },
  methods: {
    edit(index) {
      this.showModel = true;
      this.formData.address = {
        province: this.addressList[index].province,
        city: this.addressList[index].city,
        district: this.addressList[index].district
      };
      this.formData.real_name = this.addressList[index].real_name;
      this.formData.detail = this.addressList[index].detail;
      this.formData.phone = this.addressList[index].phone;
      this.formData.id = this.addressList[index].id;
      this.modelAdress =
        this.addressList[index].province +
        " " +
        this.addressList[index].city +
        " " +
        this.addressList[index].district;
    },
    editAction() {
      this.showModel = false;
      postAddress(this.formData).then(res => {
        if (res.status === 200) {
          this.$Message.success("修改成功");
          this.getAddressListMethods();
        }
      });
    },
    del(index) {
      this.$Modal.confirm({
        title: "信息提醒",
        content: "你确定删除这个收货地址",
        onOk: () => {
          getAddressRemove(this.addressList[index].id).then(res => {
            if (res.status === 200) {
              this.$Message.success("删除成功");
              this.getAddressListMethods();
            }
          });
        },
        onCancel: () => {
          this.$Message.info("取消删除");
        }
      });
    },
    getAddressListMethods() {
      getAddressList(this.param).then(res => {
        this.addressList = res.data;
      });
    },
    result2(ret) {
      this.modelAdress =
        ret.itemName1 + " " + ret.itemName2 + " " + ret.itemName3;
      this.formData.address.province = ret.itemName1;
      this.formData.address.city = ret.itemName2;
      this.formData.address.district = ret.itemName3;
    },
    changeSwitch(index) {
      const id = this.addressList[index].id;
      getAddressDefaultSet(id).then(res => {
        if (res.status === 200) {
          this.$Message.success("设置成功");
          this.getAddressListMethods();
        }
      });
    }
  },
  components: {
    CitySelect
  }
};
</script>
<style lang="stylus" scoped>
// .default-color /deep/ .ivu-switch-disabled
//   background #2d8cf0
//   &:after
//     background #fff
//     left 24 px
/deep/ .yd-cityselect-title
  font-size 16px

.my-address
  display flex
  justify-content space-between
  flex-wrap wrap
  margin 10px
  .address-box
    padding 30px 20px 20px 40px
    border-radius 5px
    border 1px solid #e7e7e7
    background #fcfcfc
    width 48%
    margin-bottom 20px
    overflow hidden
    &.active
      border-color #2c8def
      position relative
      &:after
        content: '默认地址'
        display inline-block
        background #2c8def
        width 100px
        height 24px
        line-height 24px
        font-size 12px
        position absolute
        color #fff
        text-align center
        transform rotate(-45deg)
        top 14px
        left -24px
    .address-header
      height 35px
      display flex
      justify-content space-between
      color #232323
      font-size 18px
      .default
        color #999
        font-size 14px
      .address-action
        span
          margin-left 15px
          font-size 14px
          color #2d8cf0
          cursor pointer
    .content-box
      display flex
      justify-content space-between
      .address-content
        font-size 14px
        p
          margin 5px 0
          display flex
          .address-content-title
            color #999
            width 70px
          span:last-child
            flex 1
    .setDefault
      display flex
      flex-direction row-reverse
      line-height 24px
      margin-top 10px
      .title
        margin-right 10px
        color #999
</style>
